import React from "react";
import { CountryField } from "../../reservations/guests/components/form/CountryField";
import { Button } from "@/components/ui/button";
import { LinkIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function ConnectStripeSection({
  selectedCountry,
  onSelectCountry,
  onConnect,
  loading,
  disabled,
}: {
  selectedCountry: string;
  onSelectCountry: (code: string) => void;
  onConnect: () => void;
  loading?: boolean;
  disabled?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-1">
        <h2 className="text-base font-semibold text-black/96">
          {t("billing.connectStripeTitle")}
        </h2>
        <p className="text-sm text-black/65">
          {t("billing.stripeNotConnected")}
        </p>
      </div>

      <div className="flex flex-col items-stretch gap-4 sm:flex-row sm:items-end">
        <CountryField
          className="max-w-sm flex-1"
          selectedCountry={selectedCountry ?? ""}
          onSelect={onSelectCountry}
          isEdit={!disabled}
        />

        <Button
          variant="new_default"
          size="lg"
          onClick={onConnect}
          disabled={disabled || loading}
        >
          {loading ? t("billing.connecting") : t("billing.connectStripe")}
          <LinkIcon />
        </Button>
      </div>
    </div>
  );
}
